<template>
  <div class="container">
    <header :class="{ hide: hideTitle }">
      <img class="logo" :src="require('@/assets/img/ui/sciencegroove.png')" alt="Science Groove" />
    </header>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Main',
  data() {
    return {
      hideTitle: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.hideTitle = true;
    }, 1000);
  },
};
</script>

<style>
body {
  background: #520;
  padding: 0;
  margin: 0;
  user-select: none;
}
</style>

<style lang="scss" scoped>
.container {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  header {
    z-index: 99999;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    background: rgba(255, 255, 255, 0.9);
    opacity: 1;
    transition: top 0.1s 1s, opacity 1s;

    &.hide {
      opacity: 0;
      top: -100%;
    }

    .logo {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      max-width: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Main.vue